import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { GlobalVariables } from 'app/services/globals';

import { cassandraConsistencyLevelOptions } from 'app/registries/consts/metadata-consts';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

export const cassandraTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.cassandra.datasetType,
    displayName: stringResources.Cassandra_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.cassandra.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Cassandra'
    },
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
        stringResources.VersionLabel.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-cassandra',
    isFirstClass: true,
    category: ['NoSQL'],
    supportCreatedAsV2: true,
    supportDataFlowSink: GlobalVariables.enableCassandraDataFlow,
    supportDataFlowSource: GlobalVariables.enableCassandraDataFlow,
    notSupportPhysicalType: true,
    schemaNameDisplay: stringResources.Keyspace,
    schemaAlias: 'keyspace',
    tableAlias: 'tableName',
    v1SupportSchema: true,
    copySourceControls: [
        {
            type: 'parameterizable-dropdown',
            bind: 'consistencyLevel',
            label: stringResources.ModelName_Cassandra_ConsistencyLevel,
            isLabelVertical: false,
            options: cassandraConsistencyLevelOptions
        }
    ]
};
